import React, { PureComponent } from 'react';
import MessageCard from '../../components/Cards/MessageCard.js';
import StepCompletionNotif from '../../components/Modals/StepCompletionNotif.js';
import Bubble from '../../components/Bubble.js';
import Tiles from '../../components/Tiles/index.js';
import Text from '../../components/Text.js';
import Tooltip from '../../components/Tooltip.js';
import Modal from '../../components/Modals/Modal.js';
import PlanDesignForm from './standard/index.js';
import ModularFlexDesignForm from './modular/index.js';
import Loader from '../../components/Loader.js';
import { helpers } from '@simplybenefits/sb-utils';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class PlanDesignContainer extends PureComponent {
  state = {
    classIDs: helpers.sortObjByTitle(this.props.classData),
    selectedClassID: null,
    successDialogOpen: false,
    showConfirmTypeDialog: false,
    planType: null,
    overrideModularView: false
  };
  _selectClass = selectedClassID => {
    this.setState({
      selectedClassID
    });
  };
  _toggleConfirmTypeDialog = type => {
    this.setState({
      showConfirmTypeDialog: !this.state.showConfirmTypeDialog,
      planType: type
    });
  };
  _overrideModularView = () => {
    this.setState({
      overrideModularView: !this.state.overrideModularView
    });
  };

  /**
   * Move to the Master Application
   * @private
   */
  _submit = async type => {
    let success = false;
    if (type === 'modular') {
      success = await this.props.submitModuleBlueprint(this.props.currentAccountMeta.accountID);
    } else {
      success = await this.props.submitPlanDesigns(this.props.currentAccountMeta.accountID);
    }
    if (success) {
      this.setState({
        successDialogOpen: true
      });
      this.props.setSelectedSection(null);
    }
  };
  _savePlanType = async () => {
    let type = this.state.planType === 'Modular Flex' ? 'Modular' : this.state.planType;
    this.setState({
      showConfirmTypeDialog: false
    });
    await this.props.savePlanType(type.toLowerCase());
  };
  _closeSuccessDialog = () => {
    this.setState({
      successDialogOpen: false
    });
  };
  _goToNextStep = () => {
    this.setState({
      successDialogOpen: false
    });
    this.props.setSelectedSection("commissions");
  };
  _goBack = () => {
    this.setState({
      selectedClassID: null
    });
  };
  render() {
    const {
      whitelabel
    } = this.props;
    const isModularFlex = this.props.currentAccountMeta.planType && this.props.currentAccountMeta.planType.toUpperCase() === 'MODULAR';

    // the account type has not been set yet so we need to do that
    if (!this.props.currentAccountMeta.planType) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MessageCard, {
        title: i18n.t(tokens.titles.planDesign),
        subtitle: i18n.t(tokens.labels.planDesign.welcomeToPlanDesignWizard)
      }), /*#__PURE__*/React.createElement(Tiles, {
        tiles: [{
          title: i18n.t(tokens.labels.planDesign.standard),
          description: i18n.t(tokens.labels.planDesign.traditionalPlanDesign),
          step: 1,
          icon: 'Plan Designs',
          onClick: () => this._toggleConfirmTypeDialog('Standard')
        }, {
          title: i18n.t(tokens.labels.planDesign.modularFlex),
          description: i18n.t(tokens.labels.planDesign.buildTieredOfferings),
          step: 1,
          icon: 'Plan Designs',
          onClick: () => this._toggleConfirmTypeDialog('Modular Flex')
        }]
      }), /*#__PURE__*/React.createElement(Modal, {
        open: this.state.showConfirmTypeDialog,
        onClose: () => this._toggleConfirmTypeDialog(this.state.planType),
        title: i18n.t(tokens.titles.areYouSure),
        primaryButton: {
          label: i18n.t(tokens.buttons.continue),
          onClick: this._savePlanType
        },
        loader: this.props.loader
      }, /*#__PURE__*/React.createElement(Text, {
        medium: true,
        margin: "10px 0 0 0"
      }, i18n.t(tokens.labels.planDesign.buttonBelowAccountType), /*#__PURE__*/React.createElement("b", null, `${this.state.planType}`, i18n.t(tokens.labels.planDesign.cannotBeUndone)))));
    }

    // the account type is standard and they have selected a class
    if (this.state.selectedClassID) {
      if (isModularFlex) {
        return /*#__PURE__*/React.createElement(ModularFlexDesignForm, {
          isMasterSite: this.props.isMasterSite,
          isRevision: this.props.isRevision,
          isQuote: this.props.isQuote,
          blueprint: this.props.modularBlueprints[this.state.selectedClassID],
          specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
          classID: this.state.selectedClassID,
          selectedClass: this.props.classData[this.state.selectedClassID],
          currentAccountMeta: this.props.currentAccountMeta,
          whitelabel: whitelabel,
          saveModularBlueprint: effectiveDate => this.props.saveModularBlueprint(this.state.selectedClassID, this.props.modularBlueprints[this.state.selectedClassID], effectiveDate),
          saveModularBenefitInitData: this.props.saveModularBenefitInitData,
          toggleModularViewOverride: this._overrideModularView,
          saveModularField: this.props.saveModularField,
          loader: this.props.loader,
          goBack: this._goBack,
          isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor,
          language: this.props.language || 'en'
        });
      }
      return /*#__PURE__*/React.createElement(PlanDesignForm, {
        isMasterSite: this.props.isMasterSite,
        isRevision: this.props.isRevision,
        isQuote: this.props.isQuote,
        selectedClassID: this.state.selectedClassID,
        selectedClass: this.props.classData[this.state.selectedClassID],
        designs: this.props.designs,
        specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
        currentAccountMeta: this.props.currentAccountMeta,
        goBack: this._goBack,
        whitelabel: whitelabel,
        createPlanDesign: this.props.createPlanDesign,
        createPlanDesignFromUpload: this.props.createPlanDesignFromUpload,
        savePlanDesign: this.props.savePlanDesign,
        clonePlanDesign: this.props.clonePlanDesign,
        savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
        savePlanDesignField: this.props.savePlanDesignField,
        revertToRevision: this.props.revertToRevision,
        getPlanDesignRevisions: this.props.getPlanDesignRevisions,
        getSinglePlanDesignRevision: this.props.getSinglePlanDesignRevision,
        overrideModularView: this.state.overrideModularView,
        toggleModularViewOverride: this._overrideModularView,
        loader: this.props.loader,
        isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor,
        isPrivateLabel: this.props.isPrivateLabel,
        language: this.props.language || 'en'
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, isModularFlex ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.planDesign.modularFlexPlanDesign),
      subtitle: i18n.t(tokens.labels.planDesign.welcomeToModularFlexWizard),
      btn: this.props.isQuote && this.props.step <= 2 || this.props.isRevision && this.props.step === 0,
      btnName: i18n.t(tokens.labels.planDesign.submitModularFlexDesigns),
      btnOnClick: () => this._submit('modular')
    }) : /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.planDesign),
      subtitle: i18n.t(tokens.labels.planDesign.welcomeToPlanDesignWizardClass),
      btn: this.props.isQuote && this.props.step <= 2 || this.props.isRevision && this.props.step === 0,
      btnName: i18n.t(tokens.labels.planDesign.submitPlanDesigns),
      btnOnClick: () => this._submit('standard')
    }), this.state.classIDs.map(classID => {
      const data = this.props.classData[classID];
      if (data.parentClassID) {
        return null;
      }
      return data.description ? /*#__PURE__*/React.createElement(Tooltip, {
        tip: data.description,
        placement: "top",
        arrow: true,
        display: "inline-block",
        key: classID
      }, /*#__PURE__*/React.createElement(Bubble, {
        label: `${i18n.t(tokens.titles.class)}: ${data.title}`,
        isSelected: true,
        onClick: () => this._selectClass(classID),
        clickable: true,
        customStyle: {
          marginLeft: "5px",
          marginRight: "5px"
        }
      })) : /*#__PURE__*/React.createElement(Bubble, {
        key: data.title,
        label: `${i18n.t(tokens.titles.class)}: ${data.title}`,
        isSelected: true,
        onClick: () => this._selectClass(classID),
        customStyle: {
          marginLeft: "5px",
          marginRight: "5px"
        }
      });
    }), isModularFlex ? /*#__PURE__*/React.createElement(StepCompletionNotif, {
      dialog: i18n.t(tokens.labels.planDesign.successfullySubmittedModularFlexPlan),
      type: "Plan Design",
      open: this.state.successDialogOpen,
      handleClose: this._closeSuccessDialog,
      handleNext: this._goToNextStep,
      disableBackdropClick: true,
      disableEscapeKeyDown: true
    }) : /*#__PURE__*/React.createElement(StepCompletionNotif, {
      dialog: i18n.t(tokens.labels.planDesign.successfullySubmittedPlanDesigns),
      type: "Plan Design",
      open: this.state.successDialogOpen,
      handleClose: this._closeSuccessDialog,
      handleNext: this._goToNextStep,
      disableBackdropClick: true,
      disableEscapeKeyDown: true
    }), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }));
  }
}
export default PlanDesignContainer;